<template>
    <div class="full-width">
        <div layout="column" layout-align="start start" class="full-width pr2-pc pl2-pc mb20-pc pb1-pc mb2-mobile pr1-mobile pl1-mobile bg-white">
            <div layout="row" layout-align="start center" class="title grey--text text-uppercase font-weight-medium mb2-pc mb1-mobile mt3-pc full-width">{{$t('nav.surveys')}}
                <v-btn @click="displayFilters = !displayFilters" icon class="hidden-md-and-up ml-1"><i :class="['mdi', displayFilters ? 'mdi-filter-remove' : 'mdi-filter']" style="color: black"></i></v-btn>
            </div>
            <div v-if="!$vuetify.breakpoint. smAndDown || displayFilters" layout="row" layout-wrap layout-align="start center" class="full-width">
                <div layout="column" class="subheading mb2-pc mb1-mobile font-weight-bold" flex="100">{{$t('surveys.search')}}</div>
                <div layout="column" :flex="$vuetify.breakpoint. smAndDown ? 100 : 33">
                    <v-select
                        :label="$t('params.levels')"
                        :hint="$t('filters.levels_select')"
                        persistent-hint multiple
                        solo v-model="filters.level"
                        :items="levels"
                        @change="fetch"
                        class="mr5-pc width-100-mobile"
                    >
                    </v-select>
                </div>
                <div layout="column" :flex="$vuetify.breakpoint. smAndDown ? 100 : 33">
                    <v-select
                        :label="$t('params.rds')"
                        :hint="$t('filters.rds_select')"
                        persistent-hint multiple
                        solo v-model="filters.regional_directorate_id"
                        :items="rds" item-value="id" :item-text="itemLabel"
                        @change="fetch" autocomplete
                        class="ml5-pc mr5-pc width-100-mobile"
                    >
                    </v-select>
                </div>
                <div layout="column" :flex="$vuetify.breakpoint. smAndDown ? 100 : 33">
                    <v-select
                        :label="$t('params.regions')"
                        :hint="$t('filters.regions_select')"
                        persistent-hint multiple
                        solo v-model="filters.region_id"
                        :items="regions" item-value="id" :item-text="itemName"
                        @change="fetch" autocomplete
                        class="ml5-pc width-100-mobile"
                    >
                    </v-select>
                </div>
                <div layout="column" :flex="$vuetify.breakpoint. smAndDown ? 100 : 33">
                    <v-select
                        :label="$t('params.cities')"
                        :hint="$t('filters.cities_select')"
                        persistent-hint multiple
                        solo v-model="filters.city_id"
                        :items="$store.state.cities" item-value="id" item-text="label"
                        @change="fetch" autocomplete
                        class="mr5-pc width-100-mobile"
                    >
                    </v-select>
                </div>
                <div layout="column" :flex="$vuetify.breakpoint. smAndDown ? 100 : 33">
                    <v-select
                        :label="$t('schools.title')"
                        :hint="$t('filters.schools_select')"
                        persistent-hint multiple
                        solo v-model="filters.school_id"
                        :items="schools" item-value="id" item-text="name"
                        @change="fetch" autocomplete
                        class="ml5-pc mr5-pc width-100-mobile"
                    >
                    </v-select>
                </div>
                <div layout="column" :flex="$vuetify.breakpoint. smAndDown ? 100 : 33">
                    <v-text-field solo :label="$t('filters.keywords')" :hint="$t('surveys.survey_hint')" persistent-hint v-model="filters.keywords" @keyup.enter="fetch" class="ml5-pc width-100-mobile"></v-text-field>
                </div>
                <div layout="column" :flex="$vuetify.breakpoint. smAndDown ? 100 : 33">
                    <v-select
                        :label="$t('surveys.status')"
                        :hint="$t('surveys.status_hint')"
                        persistent-hint
                        solo v-model="filters.status"
                        :items="status"
                        @change="fetch"
                        class="mr5-pc width-100-mobile"
                    >
                    </v-select>
                </div>
                <span flex></span>
                <v-btn depressed color="secondary" @click="fetch" large>{{$t('filters.filter_btn')}}</v-btn>
                {{$t('_.or')}}
                <a href="#" class="ml-2 black--text" @click.prevent="resetFilters">{{$t('filters.reinit')}}</a>
            </div>
        </div>
        <div v-if="loading" layout="row" class="bg-white full-width" style="height: 100%" layout-align="center center">
			<v-progress-circular indeterminate color="secondary" size="64"></v-progress-circular>
		</div>
        <div v-else class="full-width pl2-pc pr2-pc pt3-pc pb5-pc px1-mobile py1-mobile bg-white">
            <div class="font-weight-bold full-width mb3-pc mb1-mobile subheading">
                {{$t('surveys.list')}}
            </div>
            <div class="font-weight-bold full-width subheading">
                <span class="secondary--text">{{total}}</span>&nbsp;
                <span v-if="total > 1">
                    <span class="text-lowercase">{{$t('nav.surveys')}}</span>
                    {{$t('filters.match_pl')}} {{$t('filters.criteria')}}
                </span>
                <span v-else>
                    <span class="text-lowercase">{{$t('surveys.survey')}}</span>
                    {{$t('filters.match')}} {{$t('filters.criteria')}}
                </span>
            </div>
            <ul class="full-width list mt-3 pa-1">
                <li class="list-item mb-2 mb5-pc ml-survey-card">
                    <div layout="column" layout-align="center center" class="list-content">
                        <p></p>
                        <v-btn @click="$router.push({name: 'surveys-edit', params: {id: 'new'}})" style="width: 120px; height: 120px" icon color="#E5F7F7">
                            <v-icon size="120" color="secondary">mdi-plus</v-icon>
                        </v-btn>
                        <div class="title mt-2">
                            {{$t('surveys.add')}}
                        </div>
                        <div class="mt-4 px-2 text-xs-center caption">
                            {{$t('surveys.add_hint')}}
                        </div>
                        <p></p>
                    </div>
                </li>
                <li @click="$router.push({name: 'surveys-show-info', params: {id: s.id}})" v-for="s in surveys" :key="s.id" class="list-item clickable width-100-mobile mb-2 mb5-pc ml-survey-card">
                    <div class="list-content">
                        <div layout="row" layout-wrap layout-align="start center">
                        <v-chip label :color="surveyStatus(s, 1)" class="text-lowercase ma-0" text-color="white" small>
                            {{surveyStatus(s, 2)}}
                        </v-chip>
                        </div>
                        <div class="px-2">
                            <div class="title pa-1 mt-4">
                                {{i18n(s.title)}}
                                (<span v-for="(l,j) in s.langs" :key="l.id" class="text-uppercase">{{l.id}}{{s.langs.length == (j + 1) ? '' : ', '}}</span>)
                            </div>
                            <div class="mt-3 pa-1">{{i18n(s.description)}}</div>
                            <div class="grey--text mt-3 pa-1 mb-2">
                                {{$t('surveys.published_on')}}
                                {{formatShortDateHumanI18n(s.message.date_start)}}<br>
                                {{$t('surveys.finished_on')}}
                                {{formatShortDateHumanI18n(s.message.date_end)}}<br>
                                {{$t('surveys.lvs_targeted')}}
                                <span v-for="(l,j) in s.message.levels" :key="'lv_' + j">
                                    {{levelLabel(l.level)}}{{s.message.levels.length == (j + 1) ? '' : ', '}}
                                </span>
                            </div>
                        </div>
                        <p></p>
                        <div layout="row" layout-align="center center" class="secondary--text pa-1 mt-4">
                            <div layout="column" layout-align="center center" class="mr-5">
                                <div layout="row" layout-align="center center" class="full-width display-2 font-weight-bold">
                                    {{s.nb_questions}}
                                </div>
                                <div layout="row" layout-align="center center" class="full-width">
                                    {{ (s.nb_questions > 1) ? $t('surveys.questions') : $t('surveys.question') }}
                                </div>
                            </div>
                            <div layout="column" layout-align="center center" class="ml-5">
                            <div layout="row" layout-align="center center" class="full-width display-2 font-weight-bold">
                                {{s.nb_answers}}
                            </div>
                            <div layout="row" layout-align="center center" class="full-width">
                                {{ (s.nb_answers > 1) ? $t('surveys.answers') : $t('surveys.answer') }}
                            </div>
                            </div>
                        </div>
                        <p></p>
                        <div layout="row" layout-align="start center" class="grey--text pa-1 mt-4">
                            <avatar v-if="isMEN(s.creator) && $store.state.men_logo" size="20" :image="$store.state.men_logo" :fullname="s.created_by" class="mr-1"></avatar>
                            <avatar v-else size="20" :image="getImageData(s.creator_id)" :fullname="s.created_by" class="mr-1"></avatar>
                            {{$t('surveys.created_by')}}&nbsp;
                            <span v-if="isCurrent(s)" class="text-lowercase">
                                {{$t('_.yourself')}}
                            </span>
                            <span v-else-if="isMEN(s.creator)">
                                {{$t('_.the')}} MEN
                            </span>
                            <span v-else-if="!s.creator || s.creator.is_deleted">
                                {{$t('users.inactive')}}
                            </span>
                            <span v-else>
                                {{s.creator.firstname}} {{s.creator.lastname}}
                            </span>
                        </div>
                    </div>
                </li>
            </ul>

            <div class="text-xs-center mt-5 full-width">
                <v-pagination
                v-model="filters.page"
                :length="pages" color="secondary"
                total-visible="5"
                @input="fetch"
                ></v-pagination>
            </div>
        </div>
    </div>
</template>

<script>
    import Params from '@/api/params'
    import Surveys from '@/api/surveys'
    import Schools from '@/api/schools'
    import I18nMixin from '@/mixins/i18n'
    import Consts from '@/consts'
    import ImageMixin from '@/mixins/image'
    import Avatar from '@/components/shared/Avatar.vue'
    import Auth from '@/plugins/auth'
    import moment from 'moment'

    export default {
        mixins: [I18nMixin, ImageMixin],
        components: {Avatar},
        data () {
            return {
                filters: {
                    keywords: null,
                    is_enabled: null,
                    status: [],
                    city_id: [],
                    regional_directorate_id: [],
                    region_id: [],
                    rowsPerPage: 8,
                    descending: 1,
                    sortBy: 'created_at',
                    page: 1
                },
                storeKey: 'surveys',
                surveys: [],
                regions: [],
                rds: [],
                schools: [],
                displayFilters: false,
                total: 0,
                imgs: {},
                imgsLoad: {},
                loading: false
            }
        },
        mounted () {
          this.$store.commit('LOAD_LOGO');
          const storedFilters = this.$store.getters.getFilters(this.storeKey)
          if (storedFilters) {
            this.filters = storedFilters
          }

          this.fetch();
          this.fetchParams();
        },
        methods: {
            fetch () {
                this.loading = true;
                Surveys.getList(this.filters).then(res => {
                    this.surveys = res.data.items;
                    this.total = res.data.total;
                    this.loading = false;
                    this.imgs = {};
                    this.imgsLoad = {};
                    this.$store.commit('SET_FILTERS', {key: this.storeKey, data: this.filters})

                    for(let i = 0; i< this.surveys.length; i++){
                        if(this.surveys[i].creator && this.surveys[i].creator.avatar_id){
                            this.getImage('/assets/users/' + this.surveys[i].creator_id, this.surveys[i].creator_id);
                        }
                    }
                })
            },
            fetchParams () {
                Schools.getList({sortBy: 'name', is_enabled: 1}).then(res => {
                    this.schools = res.data;
                })
                Params.getList('regional-directorates', {is_enabled: 1}).then(res => {
                    this.rds = res.data;
                    this.rds = this.rds.sort((a,b) => (this.i18n(a.label) > this.i18n(b.label)) ? 1 : ((this.i18n(b.label) > this.i18n(a.label)) ? -1 : 0));
                })
                Params.getList('regions', {is_enabled: 1}).then(res => {
                    this.regions = res.data;
                    this.regions = this.regions.sort((a,b) => (this.i18n(a.name) > this.i18n(b.name)) ? 1 : ((this.i18n(b.name) > this.i18n(a.name)) ? -1 : 0));
                })
            },
            resetFilters () {
                this.filters = {
                    keywords: null,
                    is_enabled: null,
                    status: [],
                    city_id: [],
                    regional_directorate_id: [],
                    region_id: [],
                    rowsPerPage: 8,
                    descending: 1,
                    sortBy: 'created_at',
                    page: 1
                };
                this.fetch();
            },
            itemName(item){
                return this.i18n(item.name);
            },
            itemLabel(item){
                return this.i18n(item.label);
            },
            capitalize(str1){
                return str1.charAt(0).toUpperCase() + str1.slice(1);
            },
            surveyStatus(s, o = 1){
                if(!s.message){
                    if(o == 1){
                        return 'red';
                    } else{
                        return this.$t('surveys.suspended');
                    }
                } else if((!s.message.is_enabled || !moment().isSameOrAfter(s.message.date_start)) && !moment().isSameOrAfter(s.message.date_end)){
                    if(o == 1){
                        return 'grey';
                    } else{
                        return this.$t('surveys.draft')
                    }
                } else if(s.message.is_enabled && moment().isSameOrAfter(s.message.date_start) && moment().isSameOrBefore(s.message.date_end)){
                    if(o == 1){
                        return 'orange';
                    } else{
                        return this.$t('surveys.in_progress')
                    }
                } else{
                    if(o == 1){
                        return 'green';
                    } else{
                        return this.$t('surveys.completed')
                    }
                }
            },
            levelLabel(l){
                switch (l) {
                    case Consts.MINISTRY:
                        return this.$t('users.lv_min');
                    case Consts.NATIONAL:
                        return this.$t('users.lv_nat');
                    case Consts.SECTORAL:
                        return this.$t('users.lv_sec');
                    case Consts.LOCAL:
                        return this.$t('users.lv_loc');
                }
            },
            isMEN(c){
                if(c && (c.is_admin || c.level == Consts.MINISTRY)){
                    return true;
                }
                return false;
            },
            isCurrent(s){
                if(Auth.user.id == s.creator_id){
                    return true;
                }
                return false;
            },
        },
        computed: {
            status () {
                return [
                    { value: 1, text: this.capitalize(this.$t('surveys.draft')) },
                    { value: 2, text: this.capitalize(this.$t('surveys.in_progress')) },
                    { value: 3, text: this.capitalize(this.$t('surveys.completed')) },
                ]
            },
            levels () {
                return [
                    { value: Consts.MINISTRY, text: this.$t('users.lv_min') },
                    { value: Consts.NATIONAL, text: this.$t('users.lv_nat') },
                    { value: Consts.SECTORAL, text: this.$t('users.lv_sec') },
                    { value: Consts.LOCAL, text: this.$t('users.lv_loc') },
                ]
            },
            pages () {
                return Math.ceil(this.total / this.filters.rowsPerPage);
            },
        }
    }
</script>
<style scoped>
.survey-card {
  border: 1px solid lightgrey;
  /*height: -webkit-fill-available;*/
}
.list {
  display: flex;
  flex-wrap: wrap;
}
@media screen and (min-width: 960px) {
  .list-item {
    width: 31%;
  }
  .ml-survey-card {
    margin-left: 1.75%;
  }
}
@media screen and (max-width: 960px) {
  .list-item {
    width: 100%;
  }
}

.list-item {
  display: flex;
  border: 1px solid lightgrey;
}
.list-content {
  display: flex;
  flex-direction: column;
  background-color: #fff;
  width: 100%;
}
.list-content p {
  flex: 1 0 auto;
}
</style>
